export default __webpack_public_path__ + "static/media/PixaWitches.8c1c58f5.gif";